import { Col, Drawer, Form, Input, Row, Select, message, Upload, DatePicker, InputNumber, Radio  } from "antd"; 
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../services/util";

const { reduxStoreWrapper } = REDUX_UTIL;

const LoyaltyInfomation = ({props}) => {
    const { isOpen, setIsOpen, type, form, handleSave } = props;

    useEffect(() => {

    },[isOpen])

    const privilege = Object.values(useSelector(reduxStoreWrapper("privilege.byID")));
    const privilegeOptions = privilege.map((priv) => ({
        value: priv.feeid,
        label: priv.feeid
    }));

    const loyalty = Object.values(useSelector(reduxStoreWrapper("loyalty.byID")));
    const loyaltyOptions = loyalty.map((loy) => ({
        value: loy.ltyid,
        label: loy.name
    }))

    return (
        <>
            { type === "Revise" ? (
                <></>
            ) : (
                <>
                {/* Company Limits Revision */}
                    <Row>
                        <Col style={{ width: "100%", marginBottom: "10px", marginTop: "10px" }}>
                        <Form.Item>
                            <Row
                            style={{
                                color: "#cacaca",
                                alignItems: "center",
                                fontSize: "15px",
                            }}
                            >
                            <Col
                                span={22}
                                style={{ textAlign: "left", width: "100%" }}
                            >
                                Loyalty Infomation
                            </Col>
                            </Row>
                        </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ width: "100%", marginBottom: "10px" }}>
                            <label htmlFor="company" className="labelInput">
                                Assign privilage<span style={{ color: "red" }}>*</span>
                            </label>
                            <Form.Item
                            name="privilege"
                            rules={[
                                {
                                required: true,
                                message: "Assign privilage is required",
                                },
                            ]}
                            >
                                <Select
                                    suffixIcon={
                                        <span style={{ color: "#0E2483", fontSize: "16px" }}>
                                        Select
                                        </span>
                                    }
                                    defaultValue={form.privilege}
                                    placeholder="Select privilage"
                                    options={privilegeOptions}
                                    style={{ width: "100%", height: "3rem", alignItems: "center" }}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ width: "100%", marginBottom: "10px" }}>
                            <label htmlFor="company" className="labelInput">
                                Assign loyalty
                            </label>
                            <Form.Item
                            name="ltyid"
                            >
                                <Select
                                    suffixIcon={
                                        <span style={{ color: "#0E2483", fontSize: "16px" }}>
                                            Select
                                        </span>
                                    }
                                    placeholder="Select loyalty"
                                    options={loyaltyOptions}
                                    style={{ width: "100%", height: "3rem", alignItems: "center" }}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )}
        </>
    )
}

export default LoyaltyInfomation